module.exports = __webpack_public_path__ + "img/museo_tecnologia.21760876.jpg";